import React from "react"
import Navbar from "../../Common/Navbar"
import Footer from "../../Common/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import ReleaseNoteComp from "./Component/ReleaseNoteComp"


const ReleaseNote =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ReleaseNoteComp />
        </div>
        <Footer />
        </>
    )
}

export default ReleaseNote